export default {
  pageTitle: '新增商品',
  editorTitle: '编辑商品',
  region: '国家站',
  selectProduct: '请选择添加商品所属品类',
  selected: '已选择',
  noCategorySelected: '尚未选择',
  selectCategory: '选择品类',
  msrpContent: '将应用到本商品的每个SKU上',
  vendorProductIdMsg: '卖家自己定义的商品编号，它将应用到本商品的每个SKU上',
  onclick: '批量应用',
  oneclickContent: '为了提供卖家操作效率，我们设置了“批量地应用”按钮。可以在此区域输入市场参考价、销售价、库存和供应商商品ID等，点击按钮应用到SKU列表区域中的每一行。',
  a: '最多上传',
  b: '张主图',
  information: '商品信息',
  productTitle: '商品名称',
  shortDescription: '商品简介',
  marketingPrice: '市场参考价',
  copySKU: '该将应用到本商品的每个SKU上',
  salePrice: '售价',
  pCost: '成本价',
  vendorProductId: '供应商货号',
  sellerOrVendorCopySku: '卖家自己定义的商品编号，它将应用到本商品的每个SKU上',
  brand: '品牌',
  productPicture: '商品图片',
  sizeChartPicture: '尺码参考图',
  pleaseUploadSizeChart: '请上传尺码图',
  productVideo: '商品视频',
  the26s27m: '26秒,27M',
  reselect: '重新选择',
  notRequiredOption: ' 视频限制为30秒内，大小30M内',
  productType: '商品类型',
  multiSKU: '多SKU',
  singleSKU: '单SKU',
  defaultSpec: '默认规格项',
  inputOther: '请输入其它',
  selectedSpec: '已选规格项',
  colorDifference: 'Color通常用来描述外表差异',
  sizeappearance: 'Size通常用来描述尺寸或容量大小',
  specStyles: 'Style通常用于描述Size和Color不适用的商品规格',
  forClothing: '对于服装，如果只有颜色区别，请仅用Color',
  forMobile: '对于手机，如果只有容量区别，请仅用Size，如果有颜色和容量区别请一起用Size和Color',
  forChose: '诸如床单这类有花纹区别的商品，这些自定义的规格请用Style',
  size: 'Size',
  addSize: '添加自定义Size规格值',
  selectedSize: '已选择或添加的{spec}规格值',
  color: 'Color',
  addColor: '添加自定义的Color值',
  selectedColor: '已选择或添加的Color规格值',
  style: 'Style',
  addStyle: '添加自定义的Style值',
  selectedStyle: '已选择或添加的Style规格值',
  listsSKU: 'SKU列表',
  onClickSetting: '一键批量设置',
  listPrice: '市场参考价',
  salePrice1: '售价',
  stock: '库存',
  alertStock: '预警库存',
  imageDefault: '为没有上传SKU缩略图的SKU默认选择该商品轮播图的第一张图作为当前SKU缩略图',
  suggest: '为提升卖家操作效率而增添了一健批量设置功能。可以在此区域输入相关信息，点击一健批量设置后应用于下方所有SKU。',
  onClickApplication: '应用',
  traffic: '运输相关信息',
  grossWeight: '商品毛重',
  battery: '是否含电池',
  yes: '是',
  no: '否',
  partially: '部分',
  magnetic: '是否带磁',
  powder: '是否含粉末',
  compressionAgent: '是否含压缩剂',
  realInformation: '请如实填写以上信息. 未如实填写造成的问题如被海关扣押、禁运、用户拒收等后果将由卖家承担',
  otherInformation: '其它信息',
  selectStoreCateg: '选择店内分类',
  productDetails: '商品图文详情编辑',
  selectWarehouse: '选择仓库',
  settingsWarehouse: '仓库支付设置',
  onlinePay: '在线支付',
  COD: '货到付款',
  prePay: '预付款',
  rejectPrePay: '拒绝预付款',
  paymentMethod: '支付方式',
  online: '在线支付',
  publishOptions: '上架设置',
  saveAndList: '上架销售',
  onlySave: '暂不上架',
  listingStatusViolationTip: '本商品已违规下架，不可直接更改商品在架状态，请先提交管理员审核上架。',
  moadlTitle: '请选择',
  choose: '选择',
  operation: '操作',
  mainPicture: '缩略图',
  notApplied: '您没有输入任何信息，未能执行',
  selectAnotherCategory: '选择其它分类',
  selectThirdCategories: '请选择三级分类',
  upload5Images: '最多可以上传{0}张图片',
  JPG_GIF_PNG: '请上传JPG/GIF/PNG类型的图片',
  fileToBig: '文件过大，单个文件上限为2M',
  Main10Image: '最多上传10张主图',
  specification: '规格值已存在',
  MP4Format: '只支持mp4格式的视频',
  lessThan_30s: '视频时长在30秒以内',
  noMoreThan_30M: '视频大小在30M以内',
  uploadMainPic: '请上传主图!',
  SaleThenMarketing: '售价不能高于市场参考价！',
  pleaseProductTitle: '请输入商品标题！',
  selectStoreCategory: '请选择店内分类！',
  packinglistempty: '包装清单不能为空',
  uploadPictures: '请上传图片！',
  PleaseSKU: '请添加规格',
  PleaseGrossWeight: '请填写毛重！',
  pleaseSelectProp: '请选择属性',
  pleasePaymentMethod: '请设置支付方式！',
  pleaseWarehouse: '请选择仓库！',
  pleaseStock: '请填写库存！',
  selectPicture: '请选择图片！',
  enterPCost: '请输入成本价！',
  pleaseSelectedSpec: '请选择规格！',
  confirmation: '确认',
  only_10_file: '一次最多只能上传10个文件',
  nothing: '无',
  rmb: '人民币',
  yen: '日元',
  pCostPrompt: '参考 FOB 价格，单位为人民币',
  // ES023
  liquid: '是否含液体',

  whiteImg: '白底图',
  spec: '属性',
  packingListTips: '为了避免产生不必要的售后，请尽量将产品清单填写完整',
  packinglist: '包装清单',
  highSensitiveProducts: '高敏感货物',
  generalProduct: '普通货物',
  phoneTabletLaptop: '手机/平板/电脑',
  specialProduct: '特殊货物(粉尘、液体、膏状)',
  electronicsGoods: '电磁货品（带电池、充电器、带磁体）',
  classification: '货物类型',
  requirementsWhite: '点击查看上传规范',
  pleaseBrand: '请选择品牌',
  theInfoDuplicatedNot: '复制产品的信息不能与原商品相同',
  storeFrozen: '店铺在所选择的国家站已冻结。',
  setActive: '上架',
  setInactive: '下架',
  nonFbk: '非FBK:{0} (可用.',
  fbk: 'FBK:{0} (可用. {1})',
  changeNonFbkInventory: '增减非FBK库存',
  recentlyUsed: '最近使用',
  inputKeyWordSearch: '输入你想找的品类关键词',
  applyToAllVariants: '应用于全部SKU',
  applyToPartialVariants: '应用于部分SKU',
  chooseVariationName: '选择规格项',
  chooseVariationValue: '选择规格值',
  availInventoryNonFBK: ' 可用库存 (非FBK)',
  mustBeGreaterZero: '必须大于0',
  roughWeightRadix: '请填写毛重，且只能输入数字，保留两位小数！',
  roughWeightRequired: '请填写毛重',
  pleaseSelectShape: '请选择形状',
  pleaseSelectLength: '请输入长度',
  pleaseSelectWidth: '请输入宽度',
  pleaseSelectHeight: '请输入高度',
  pleaseSelectClassification: '请选择分类',
  invalidSpecVariantValue: '您输入的规格属性值无效',
  pleaseEnterContent: '请输入内容',
  customCodeNameValid: '海关商品名必须含汉字，不允许特殊字符，长度不超过100个字节',
  productNameValid: '中文品名必须含有汉字，不能有特殊字符，且长度不超过100个字节。',
  imageTip: {
    product1: '1. 这是商品详情页上展示给客户的商品主图，最多可上传10张图片，可以通过拖拽来改变图片顺序',
    product2: '2. 每张图片必须是正方形，建议 500x500 像素',
    product3: '3. 每张图片文件大小不超过 1 MB'
  },
  videoTip: {
    product1: '1. 这是商品详情页上展示给客户的商品介绍视频，仅支持上传1个视频',
    product2: '2. 视频播放长度不超过30秒',
    product3: '3. 视频文件的大小不超过 30MB'
  },
  pleaseSelectSellingPrice: '请输入售价',
  pleaseSelectListPrice: '请输入参考价',
  priceTypeError: '请输入正确格式的售价',
  stockTypeError: '请输入正确的库存格式',
  pleaseListingDetail: '请输入商品详情数据',
  productCreateSuccess: '商品创建成功',
  productEditSuccess: '商品编辑成功',
  productCreateSuccessTips: '你的商品创建成功, 可以在买家端进行浏览和检查, 确保一切完美无缺',
  productEditSuccessTips: '你的商品编辑成功, 可以在买家端进行浏览和检查, 确保一切完美无缺',
  viewLiveProduct: '查看商品详情',
  editProduct: '编辑商品',
  valueAlreadyExists: '创建失败：该值已存在',
  customizeValueMaxLength: '自定义值长度不能超过 {max} 个字符',
  warrantyCustomFormatInvalid: '无法识别质保时长，请检查填写格式',
  warrantyCustomNoCategory: '请先选择商品类目后再设置质保',
  warrantyCustomCategoryCheckFailed: '品类质保要求校验失败，请稍后重试',
  warrantyNoReasonReturnPolicyLink: '平台7天无理由退货政策和要求>>',
  thereModificationApproval: '有正在审核中的修改申请',
  theModificationReached: '已达到修改次数限制'
}
